import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const sessionStorage = {
  getItem: <T>(key: string, initialValue: T): T => {
    // SSR-safe: no window on the server. Lets atoms use `getOnInit` without
    // crashing during server render (they fall back to the initial value).
    if (typeof window === 'undefined') return initialValue;
    const item = window.sessionStorage.getItem(key);
    const iso8601Regex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d{1,3})?Z$/;
    return item ? JSON.parse(item, (key, value) => {
      return typeof value === 'string' && iso8601Regex.test(value) ? new Date(value) : value;
    }) : initialValue;
  },
  setItem: <T>(key: string, value: T): void => {
    if (value === null) {
      window.sessionStorage.removeItem(key); // no null values we have initial values
    } else {
      window.sessionStorage.setItem(key, JSON.stringify(value, (key, value) => {
        return value instanceof Date ? value.toISOString() : value;
      }));
    }
  },
  removeItem: (key: string): void => window.sessionStorage.removeItem(key)
}

